export default "/images/c91bb2ba829163f57dcb2704038a1c5a.avif";